export const FileActionTypes = {
  FILE_UPLOADING: 'zola/cards/file/FILE_UPLOADING',
  FILE_UPLOADED: 'zola/cards/file/FILE_UPLOADED',
  STORE_REFERENCE_KEY: 'zola/cards/file/STORE_REFERENCE_KEY',
  UPLOAD_INTERRUPTED: 'zola/cards/file/UPLOAD_INTERRUPTED',
  IS_BUSY: 'zola/cards/modal/IS_BUSY', // this should not be here, kept to maintain compatability with handleFailedSubmit action below
};

export default FileActionTypes;
